import { PasseriniAPI } from '@/services/apiService';
import { 
  LoginParams, 
  LoginResponse, 
  TokenParams, 
  CreateUserParams, 
  ChangePasswordParams, 
  UpdateOwnPasswordParams,
  NotifyCredentialsParams,
  Usuario
} from '../types';
import { AUTH_ENDPOINTS } from '../constants';

/**
 * Auth service - handles all authentication-related API calls
 */
export class AuthService {
  /**
   * Login user with email and password
   */
  static async login({ email, password }: LoginParams) {
    return PasseriniAPI.post<LoginResponse>(AUTH_ENDPOINTS.LOGIN, { email, password });
  }

  /**
   * Get current user data by token
   */
  static async getUser({ token }: TokenParams) {
    return PasseriniAPI.get<{ user: Usuario }>(AUTH_ENDPOINTS.USER, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });
  }

  /**
   * Logout user
   */
  static async logout({ token }: TokenParams) {
    return PasseriniAPI.post(AUTH_ENDPOINTS.LOGOUT, undefined, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    });
  }

  /**
   * Create new user
   */
  static async createUser({ user }: CreateUserParams): Promise<any> {
    const response = await PasseriniAPI.post(AUTH_ENDPOINTS.REGISTER, user);
    return response.data;
  }

  /**
   * Change user password
   */
  static async changePassword({ user }: ChangePasswordParams): Promise<any> {
    const response = await PasseriniAPI.patch(AUTH_ENDPOINTS.CHANGE_PASSWORD, user);
    return response.data;
  }

  /**
   * Change authenticated user password
   */
  static async updateOwnPassword({ user }: UpdateOwnPasswordParams): Promise<any> {
    const response = await PasseriniAPI.put(AUTH_ENDPOINTS.USER_PASSWORD, user);
    return response.data;
  }

  /**
   * Notify user credentials
   */
  static async notifyCredentials({ user }: NotifyCredentialsParams): Promise<any> {
    const response = await PasseriniAPI.post(AUTH_ENDPOINTS.NOTIFY_CREDENTIALS, user);
    return response.data;
  }
}

// Export individual functions for backward compatibility
export const { login, getUser, logout, createUser, changePassword, updateOwnPassword, notifyCredentials } = AuthService;
